import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useDeviceType, InformationTooltip, Button } from '@cian/ui-kit';

import { FooterAction } from '../../components/FooterAction';
import { saveReportAction, toggleSaveReportError } from '../../actions/report';
import { IApplicationState, TThunkDispatch } from '../../types/redux';

export const SaveReportContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const isDesktop = useDeviceType() === 'desktop';
  const isLoad = useSelector((state: IApplicationState) => state.report.isSaveLoading);
  const errorText = useSelector((state: IApplicationState) => state.report.errorText);

  const handleClick = React.useCallback(() => {
    dispatch(saveReportAction());
  }, [dispatch]);

  const handleTooltipClose = React.useCallback(() => {
    dispatch(toggleSaveReportError(''));
  }, [dispatch]);

  return (
    <InformationTooltip content={errorText} open={Boolean(errorText)} onClose={handleTooltipClose}>
      <FooterAction
        title="Отправьте отчёт от своего имени"
        subTitle="Добавьте комментарии для клиента"
        action={
          <Button theme="fill_primary" size="M" onClick={handleClick} fullWidth={!isDesktop} loading={isLoad}>
            Сформировать отчет
          </Button>
        }
      />
    </InformationTooltip>
  );
};

SaveReportContainer.displayName = 'SaveReportContainer';
